import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// The options below MUST stay a static literal.
//
// Vuetify 2.x merges this object into its defaults with an unsafe recursive
// mergeDeep (CVE-2025-8083, prototype pollution). There is no fix on the 2.x
// line. We accept the risk only because nothing attacker-controlled can reach
// this argument. Do not spread or merge runtime data (API config, cookies,
// query string, localStorage) in here — that would make the CVE live.
//
// Need dynamic theming? Read docs/SECURITY-EXCEPTIONS.md first.
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
});